import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  /* Remove o header original */
  header.sc-gyycJP {
    display: none !important;
  }
`; 